export default __webpack_public_path__ + "static/media/rx5700.949b5395.jpg";